import { postCheckout } from 'api/checkoutpage';
import { useMutation } from 'react-query';
import axios, { AxiosError } from 'axios';
import { useIntl } from 'react-intl';
import { usePopup } from 'context/PopupContext/PopupContext';
import { withTokenRefresh } from 'utils/withTokenRefresh';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'router/routes';

export const useCheckoutMutation = () => {
  const { showPopup } = usePopup();
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  const { mutate, status, isError } = useMutation(
    (data: any) => withTokenRefresh(() => postCheckout(data)),
    {
      onSuccess: (data) => {
        if (!data.orderNumber) {
          showPopup({
            message: formatMessage({ id: 'checkout.orderNotConfirmed' }),
            type: 'ERROR',
          });
          return;
        }
        if (!data.paymentLink) {
          navigate(`/${ROUTES.summary}?CartID=${encodeURIComponent(data.orderNumber)}`);
          return;
        }
        window.location.replace(data.paymentLink);
      },

      onError: (e: AxiosError | Error) => {
        console.error('Error:', e);
        if (axios.isAxiosError(e)) {
          showPopup({
            message: e.response?.data?.message || e.message,
            type: 'ERROR',
          });
        }
      },
    },
  );

  return {
    mutate,
    isError,
    status,
  };
};
